import { HealthRecordsDocuments } from "../ui-components"
import { useNavigate } from "react-router-dom";


const HealthRecordsDocumentsPage = () => {
    const navigate = useNavigate();
    return (
      <HealthRecordsDocuments
        overrides={{
          DocumentsCard: {
            overrides: {
              dcRowTitle39372592: {
                onClick: () => navigate("/user/hr/documents/mri"),
              },
              dcAddMore: {
                onClick: () => navigate("/user/hr/documents/add"),
              },
            },
          },
        }}
      />
    );
}

export default HealthRecordsDocumentsPage;